"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ZipFileState = void 0;
var ZipFileState;
(function (ZipFileState) {
    ZipFileState["GeneratingParticipantsZip"] = "generatingParticipantsZip";
    ZipFileState["DeletingParticipantsZip"] = "deletingParticipantsZip";
})(ZipFileState = exports.ZipFileState || (exports.ZipFileState = {}));
//# sourceMappingURL=zip-file-state.js.map